import findTicketsUseCase from "../findTicketsUseCase"

export const SET_ALL_DATA = 'SET_ALL_DATA_TICKETS'
export const SET_ITEM = 'SET_ITEM_TICKETS'
export const DELETE_ITEM = 'DELETE_ITEM_TICKETS'

const setAllData = payload => (
    { type: SET_ALL_DATA, payload }
)

const setItem = payload => (
    { type: SET_ITEM, payload }
)

const deleteItem = payload => (
    { type: DELETE_ITEM, payload }
)


export const getTicketsAction = payload => {
    return async (dispatch, getState) => {

        findTicketsUseCase(snapshot => {
            const { added, modified, removed } = getDataFromSnapshot(snapshot)
            
            if (getState().tickets.data.length === 0) {
                dispatch(setAllData(added))
            } else {
                Object.entries(added).forEach(([key, value]) => dispatch(setItem({ id: key, data: value })));
                Object.entries(modified).forEach(([key, value]) => dispatch(setItem({ id: key, data: value })));
                Object.entries(removed).forEach(([key, value]) => dispatch(deleteItem({ id: key })));
            }
        })
    }
}

const getDataFromSnapshot = (snapshot) => {
    let data = {
        added: {},
        modified: {},
        removed: {}
    }

    snapshot.docChanges().forEach(change => {
        const type = data[change.type]
        type[change.doc.id] = applyTransformData(change.doc.data())
    })

    return data
}

const applyTransformData = (tickets) => {
    return { ...tickets }
}